import { useQuery } from "@tanstack/react-query";
import { getBalance } from "../api";
import type { BalanceContent } from "../types";

/**
 * Custom hook to fetch the Stripe balance using React Query.
 *
 * @param {boolean} condition - A boolean condition to determine if the query should be enabled.
 * @returns {Object} - The query object containing data, loading, and error states.
 */
export const useBalance = (
  condition: boolean
): ReturnType<typeof useQuery<BalanceContent>> => {
  return useQuery<BalanceContent>({
    queryKey: ["balance"], // Unique key for this query
    queryFn: getBalance, // The function to fetch the data
    staleTime: 1000 * 60 * 5, // Data is considered fresh for 5 minutes
    retry: 2, // Retry failed requests twice
    enabled: condition, // Only fetch data if the condition is true
  });
};
